import { styled } from "@mui/material";
const blockedProps = /* @__PURE__ */ new Set(["multiline", "density"]);
function defaultComputeGap(density, multiline) {
  switch (density) {
    case "collapsed":
      return 0;
    case "compact":
      return 0.25;
    case "comfortable":
      return multiline ? [1.5, 1] : 1;
    case "standard":
    default:
      return multiline ? [0.75, 0.5] : 0.5;
  }
}
const Content = styled("div", {
  slot: "Root",
  name: "TruncateContent",
  skipSx: true,
  shouldForwardProp: (prop) => !blockedProps.has(prop)
})(({ theme, multiline, density, computeGap = defaultComputeGap }) => {
  let gap = "0";
  if (typeof computeGap === "number") {
    gap = theme.spacing(computeGap);
  } else {
    const gapResult = computeGap(density, multiline);
    if (Array.isArray(gapResult)) {
      gap = theme.spacing(gapResult[0], gapResult[1]);
    } else {
      gap = theme.spacing(gapResult);
    }
  }
  return `
    position: relative;
    overflow: hidden;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: ${multiline ? "flex-start" : "center"};
    flex-wrap: ${multiline ? "wrap" : "nowrap"};
    gap: ${gap};
    flex: 0 1 auto;
    align-content: flex-start;
    padding: 0;
  `;
});
export {
  Content
};
//# sourceMappingURL=Content.js.map
